import * as modal from "../modal";
import { fireEvent } from "../events";

export function continueToApplication (){
    modal.hideDeprecatedBrowserMessage();
    ConfigChecker.checkSecurityPackage({ forceAccess: true });
}

export function updateBrowser (){
    modal.hideDeprecatedBrowserMessage();
    fireEvent('oldBrowser');
}